import { useGetDuplicateCount } from "AccountMerge/duplicatesApi/queries";

const useDuplicateCount = () => {
  const { data } = useGetDuplicateCount();

  return data?.numberOfDuplicates || 0;
};
const useHasDuplicates = () => {
  const duplicateCount = useDuplicateCount();

  return duplicateCount > 0;
};

export { useHasDuplicates, useDuplicateCount };
